const React = require('react');
const moment = require('moment');
const Table = require('react-bootstrap').Table;


var ServiceDebuggerVisionData = React.createClass({
    propTypes: {
        data: React.PropTypes.object.isRequired
    },
    formatBpsFromKbps: function (bytes, decimals = 2) {
        if (!bytes) {
            return '';
        }
    
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['kbps', 'Mbps', 'Gbps', 'Tbps', 'Pbps', 'Ebps', 'Zbps', 'Ybps']
    
        const i = Math.floor(Math.log(bytes) / Math.log(k))
    
        return `${(bytes / Math.pow(k, i)).toFixed(dm)} ${sizes[i]}`
    },
    render: function () {
        var data = this.props.data;
        var now = moment(new Date());

        return (
            <div>
                <h4>Vision details</h4>
                <Table className="table-striped table-hover">
                    <tbody>
                        <tr>
                            <th>
                                Date/Time
                            </th>
                            <td>
                                {now.format('LLLL')}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Service State
                            </th>
                            <td>
                                {data.service_state}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Last Status Change
                            </th>
                            <td>
                                {data.last_status_change ? moment.unix(Date.parse(data.last_status_change)/1000).format('LLLL') : 'Unknown'}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Router CPE MAC
                            </th>
                            <td>
                                {data.router_cpe_mac}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                NTU CPE MAC
                            </th>
                            <td>
                                {data.ntu_cpe_mac}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                NTU CPE Make
                            </th>
                            <td>
                                {data.ntu_cpe_make}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                NTU CPE Model
                            </th>
                            <td>
                                {data.ntu_cpe_model}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                NTU CPE Serial Number
                            </th>
                            <td>
                                {data.ntu_cpe_serial}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                NTU CPE Firmware Version
                            </th>
                            <td>
                                {data.ntu_cpe_firmware}
                            </td>
                        </tr>
                    </tbody>
                </Table>

                <h5>Line Rates</h5>
                <Table className="table-striped table-hover">
                    <tbody>
                        <tr>
                            <th>
                                Actual Line Rate (Down)
                            </th>
                            <td>
                                {this.formatBpsFromKbps(data.actual_line_rate_down)}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Attainable Line Rate (Down)
                            </th>
                            <td>
                                {this.formatBpsFromKbps(data.attainable_line_rate_down)}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Actual Line Rate (Up)
                            </th>
                            <td>
                                {this.formatBpsFromKbps(data.actual_line_rate_up)}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Attainable Line Rate (Up)
                            </th>
                            <td>
                                {this.formatBpsFromKbps(data.attainable_line_rate_up)}
                            </td>
                        </tr>
                    </tbody>
                </Table>

                <h5>Dropouts</h5>
                <Table className="table-striped table-hover">
                    <tbody>
                        <tr>
                            <th>
                                Today
                            </th>
                            <td>
                                {data.dropouts ? data.dropouts.today : ''}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Yesterday
                            </th>
                            <td>
                                {data.dropouts ? data.dropouts.yesterday : ''}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Two Days Ago
                            </th>
                            <td>
                                {data.dropouts ? data.dropouts.two_days : ''}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Seven Days Ago
                            </th>
                            <td>
                                {data.dropouts ? data.dropouts.seven_days : ''}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Thirty Days Ago
                            </th>
                            <td>
                                {data.dropouts ? data.dropouts.thirty_days : ''}
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        );
    }
});

module.exports = ServiceDebuggerVisionData;



// WEBPACK FOOTER //
// ./app/components/ServiceDebugger/ServiceDebuggerVisionData.js